import { Spin, type SpinProps } from "antd"
import type { ComponentProps } from "react"
import { cn } from "styles/cn"

export const Spinner = ({
	className,
	classNames,
	rootClassName,
	indicator,
	children,
	...props
}: SpinProps) => (
	<Spin
		{...props}
		rootClassName={cn(
			children
				? "h-full min-h-full"
				: "flex min-h-full items-center justify-center",
			className,
			rootClassName,
		)}
		indicator={indicator ?? <Indicator />}
		classNames={{ section: "z-0", container: "h-full" }}
	>
		{children}
	</Spin>
)

export const Indicator = ({ className, ...props }: ComponentProps<"div">) => (
	<div
		{...props}
		className={cn(
			"size-5 animate-spin rounded-[50%] border-6 border-green-60 border-r-transparent",
			className,
		)}
	/>
)
